







































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Solution } from "@/services/solutions/types";
import { powerPlanSolutionFields } from "@/components/powerPlans/fields/powerPlanSolutionFields";
import SelectSolutionModal from "@/components/solutions/modals/SelectSolutioModal.vue";
import { addContentValidators } from "@/components/backgrounds/validators";
import SolutionInfoModal from "@/components/solutions/modals/SolutionInfoModal.vue";
@Component({
    components: { SelectSolutionModal, SolutionInfoModal }
})
export default class PowerPlanSolutions extends Vue {
    @Prop() collapseState!: boolean;
    @Prop() solutions!: Solution[];

    // local state
    localSolutions = [] as Solution[];
    localCollapseState = true;
    fields = powerPlanSolutionFields;
    isBusy = false;

    // filter options
    searchQuery = "";

    // watchers
    @Watch("solutions")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localSolutions = this.solutions;
    }

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
    }

    // computed
    get filteredData() {
        return (
            this.localSolutions &&
            this.localSolutions.filter(
                x =>
                    this.searchQuery.length === 0 ||
                    x.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            )
        );
    }

    // methods
    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "PowerPlanSolutions", state: state });
    }

    addSolution() {
        (this.$refs.solutionAddModal as any).open(null, false, true);
    }

    removeSolution(id: string) {
        const item = this.localSolutions.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.localSolutions = this.localSolutions.filter(x => x.id !== id);
    }

    onSelectedSolution(solutions: Solution[]) {
        if (!solutions || solutions.length === 0) { return; }
        this.localSolutions = this.localSolutions.concat(solutions);
    }

    solutionInfo(solutionId: string) {
        (this.$refs.solutionInfoModal as any).open(solutionId);
    }

    emitData() {
        // deep copy to avoid binding
        this.$emit("solutionsUpdated", JSON.parse(JSON.stringify(this.localSolutions)));
    }
}
